import { render, staticRenderFns } from "./TerritoryCanteens.vue?vue&type=template&id=c128019c&"
import script from "./TerritoryCanteens.vue?vue&type=script&lang=js&"
export * from "./TerritoryCanteens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports